import { type FC, useMemo } from 'react';
import type { RefObject } from 'react';

import Spreadsheet from '@/components/UI/SpreadSheet/Spreadsheet';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';

import type { SampleTypeRow } from '@/model/SampleType.model';
import type { ValidationData } from '@/utils/sampleTypeValidation';

import { buildColumns, initBulkAddSampleTypesSettings } from './BulkAddSampleTypes.utils';

interface HotTableRefLike {
  hotInstance?: unknown;
}

interface BulkAddSampleTypesTableProps {
  data: Array<SampleTypeRow | []>;
  innerRef: RefObject<HotTableRefLike | null>;
  validationData: ValidationData | null;
  availableDetailOptions: Array<string>;
  setInvalid: (invalid: boolean) => void;
}

const BulkAddSampleTypesTable: FC<BulkAddSampleTypesTableProps> = ({
  data,
  innerRef,
  validationData,
  availableDetailOptions,
  setInvalid,
}) => {
  const columns = useMemo(
    () =>
      buildColumns({
        availableDetailOptions,
        validationData,
        hotTableRef: innerRef,
      }),
    [availableDetailOptions, validationData, innerRef]
  );

  const settings = useMemo<SpreadsheetSettings>(() => initBulkAddSampleTypesSettings(columns), [columns]);

  return (
    <div className="mv3 w-100 overflow-auto ow-spreadsheet-styles">
      <Spreadsheet
        className="mt3"
        testPrefix="bulk-add-sample-types"
        data={data as unknown as Array<Record<string, unknown>>}
        innerRef={innerRef as RefObject<HotTableRef>}
        settings={settings}
        addCol={false}
        modalView={true}
        fillHandle={false}
        autoAddRow
        enableRowHeaderControls
        setInvalid={setInvalid}
      />
    </div>
  );
};

export default BulkAddSampleTypesTable;
